/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTicket} from '../api'

 export const useQueryGetTicket = createReactQueryHook('getTicket', getTicket)
